import React from "react";
import styles from "./ListMessage.module.css";

interface LinkAttachment {
  type: string;
  payload: {
    thumbnail: string;
    description: string;
    title: string;
    url: string;
  };
}

interface MessageData {
  msg_id: string;
  text: string;
  attachments: LinkAttachment[];
}

interface ListMessageProps {
  messageId?: string;
  messageData?: MessageData;
}

const isEmpty = (value?: string) =>
  value === undefined || value === null || value.trim() === "";

export const ListMessage: React.FC<ListMessageProps> = ({
  messageId,
  messageData,
}) => {
  const linkAttachment = messageData?.attachments?.find(
    (att) => att.type === "link"
  );

  const finalTitle = linkAttachment?.payload?.title || messageData?.text || "";
  const finalDescription = linkAttachment?.payload?.description || "";
  const finalThumbnailUrl = linkAttachment?.payload?.thumbnail || "";
  const finalLinkUrl = linkAttachment?.payload?.url || "";
  const finalMessageId = messageData?.msg_id || messageId;

  if (
    isEmpty(finalTitle) &&
    isEmpty(finalDescription) &&
    isEmpty(finalThumbnailUrl) &&
    isEmpty(finalLinkUrl)
  ) {
    return null;
  }

  const handleLinkClick = () => {
    if (!isEmpty(finalLinkUrl)) {
      window.open(finalLinkUrl, "_blank");
    }
  };

  return (
    <div className={styles.itemMessage} data-message-id={finalMessageId}>
      {!isEmpty(finalTitle) && (
        <span className={styles.content}>
          <span>{finalTitle}</span>
        </span>
      )}
      {(!isEmpty(finalThumbnailUrl) ||
        !isEmpty(finalTitle) ||
        !isEmpty(finalDescription) ||
        !isEmpty(finalLinkUrl)) && (
        <div className={styles.thumbnailCard} onClick={handleLinkClick}>
          {!isEmpty(finalThumbnailUrl) && (
            <img
              className={styles.img}
              src={finalThumbnailUrl}
              alt={finalTitle}
            />
          )}
          <div className={styles.thumbnailInfo}>
            {!isEmpty(finalTitle) && (
              <div className={styles.thumbnailTitle}>{finalTitle}</div>
            )}
            {!isEmpty(finalDescription) && (
              <div className={styles.thumbnailDesc}>{finalDescription}</div>
            )}
            {!isEmpty(finalLinkUrl) && (
              <a
                href={finalLinkUrl}
                target="_blank"
                rel="noopener noreferrer"
                className={styles.thumbnailLink}
                onClick={(e) => e.stopPropagation()}
              >
                zalo.me
              </a>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

